export default "__VITE_ASSET__DJykalk1__"